import Header from "../../components/shared/Header";
import Agents from "./Agents";
import AiAgents from "./AiAgents";
import Footer from "./Footer";
import Hero from "./Hero";
import Information from "./Information";
import OurBenefits from "./OurBenefits";
import Partners from "./Partners";
import Roadmap from "./Roadmap";
import Tokenomics from "./Tokenomics";

export default function Home() {
	return (
		<>
			<Header />

			<Hero />

			<Partners />

			<OurBenefits />

			<AiAgents />

			<Agents />

			<Roadmap />

			<Tokenomics />

			<Information />

			<Footer />
		</>
	);
}
